import React from "react";
import PricePlan from "../../Models/PricePlan";
import { Button, DialogContent, GridLegacy, Paper, Typography } from "@mui/material";
import { useDialog } from "../../utils/DialogProvider";
import GridRowDescriptionWithTextField from "../components/EditFields/GridRowDescriptionWithTextField";
import Debtor from "../../Models/Debtor";
// @ts-ignore
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
// @ts-ignore
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete.jsx";

type EditPricePlanProps = {
  pricePlan: PricePlan;
  onSave: (pricePlan: PricePlan) => Promise<any>;
};

function EditPricePlan(props: EditPricePlanProps) {
  const [pricePlan, setPricePlan] = React.useState<PricePlan>(props.pricePlan);
  const [debtor, setDebtor] = React.useState<Debtor | null>(null);
  const [, closeDialog] = useDialog();
  return (
    <DialogContent>
      <Paper>
        <Typography variant={"h6"}>PricePlan</Typography>

        <GridLegacy container spacing={1} style={{ maxWidth: 480 }}>
          <GridLegacy container item xs={12}>
            <GridRowDescriptionWithTextField
              description={"Name"}
              onChange={(e) => {
                pricePlan.name = e.target.value;
                setPricePlan(Object.assign(Object.create(pricePlan), pricePlan));
              }}
              value={pricePlan.name}
            />
          </GridLegacy>
          <GridLegacy container item xs={12}>
            <GridRowDescriptionWithTextField
              description={"Description"}
              onChange={(e) => {
                pricePlan.description = e.target.value;
                setPricePlan(Object.assign(Object.create(pricePlan), pricePlan));
              }}
              value={pricePlan.description}
            />
          </GridLegacy>

          <GridLegacy container item xs={12}>
            <GridLegacy item xs={6}>
              <TranslationWrapper tKey={"Commission debtor"} />
            </GridLegacy>
            <GridLegacy item xs={6}>
              <AsynchronousAutocomplete
                async={{
                  url: "core/subsDebtor/search?fields=id as value, company_name as label&per_page=30",
                  searchField: "company_name",
                }}
                defaultValue={debtor ? { value: debtor.id, label: debtor?.company_name } : null}
                onChange={(e: any, option: any) => {
                  setDebtor(option);
                  pricePlan.subs_debtor_id = option?.value;
                  setPricePlan(Object.assign(Object.create(pricePlan), pricePlan));
                }}
              />
            </GridLegacy>
          </GridLegacy>

          {props.onSave ? (
            <GridLegacy container item justify={"center"} xs={12}>
              <Button
                color={"primary"}
                onClick={() => {
                  if (props.onSave) {
                    props.onSave(pricePlan).then(() => {
                      closeDialog();
                    });
                  }
                }}
                variant={"contained"}
              >
                Save
              </Button>
            </GridLegacy>
          ) : null}
        </GridLegacy>
      </Paper>
    </DialogContent>
  );
}

export default EditPricePlan;
